// apps/web/src/api/search.ts
// 搜索 + 统计 API

import api from "./client";

export interface SearchResultItem {
  question: {
    id: string;
    bank_id: string;
    type: string;
    content: string;
    options: string[] | null;
    correct_answer: string;
    explanation: string | null;
    chapter: string | null;
    difficulty: number | null;
    tags: string[] | null;
    source_file_id: string | null;
    sort_order: number;
    created_at: number;
    updated_at: number;
  };
  bank_id: string;
  bank_name: string;
}

export interface DashboardStats {
  total_banks: number;
  total_questions: number;
  wrong_count: number;
  favorite_count: number;
  note_count: number;
  recent_banks: {
    id: string;
    name: string;
    tag: string | null;
    question_count: number;
    last_studied_at: number | null;
  }[];
}

function buildQuery(opts: Record<string, string | number | undefined>): string {
  const params = new URLSearchParams();
  for (const [key, val] of Object.entries(opts)) {
    if (val !== undefined && val !== null) params.set(key, String(val));
  }
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

/** 搜索题目 */
export async function searchQuestionsApi(opts: {
  q: string;
  page?: number;
  page_size?: number;
  bank_id?: string;
  type?: string;
}): Promise<{ items: SearchResultItem[]; total: number }> {
  return api.get(`search${buildQuery(opts)}`);
}

/** 获取 Dashboard 统计 */
export async function getStatsApi(): Promise<DashboardStats> {
  return api.get("stats");
}
